import React from "react";
import { Link } from "react-router-dom";
import "./HeroSection.css";

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="hero-video-container">
        <video
          autoPlay
          muted
          loop
          className="hero-video"
          playsInline
          poster="https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80"
        >
          <source src="/videos/hero_video.mp4" type="video/mp4" />
          <source src="/videos/hero_video.webm" type="video/webm" />
          Your browser does not support the video tag.
        </video>
        <div className="hero-overlay"></div>
      </div>

      <div className="hero-content">
        <div className="container">
          <h1 className="hero-title">
            {/* Logo image instead of # */}
            {/* <img 
              src="/logos.png" 
              alt="SeagullPartners Logo" 
              className="hero-logo"
              onError={(e) => {
                // Fallback if logo image doesn't load
                e.target.style.display = 'none';
                const fallback = document.createElement('span');
                fallback.className = 'hero-logo-fallback';
                fallback.textContent = '#';
                e.target.parentElement.insertBefore(fallback, e.target);
              }}
            /> */}
            <span className="hero-title-text">
              Sharp Eyes for Your Next Big Lead
            </span>
          </h1>
          <p className="hero-subtitle">
            Accuracy is your greatest advantage. At Seagull Partners, we scout the market with sharp eyes to find your most profitable leads. We don’t just provide data—we deliver your next big opportunity
          </p>
          <div className="hero-buttons">
            <Link to="/contact" className="btn hero-btn primary">
              Get a Free Consultation
            </Link>
            <Link to="/solutions" className="btn hero-btn secondary">
              Explore Our Solutions
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="scroll-indicator">
        <div className="mouse">
          <div className="wheel"></div>
        </div>
        <div className="arrow">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;